module.exports = __webpack_public_path__ + "img/40_38_052_130.df019589.jpg";